import React, { useContext } from "react";

export interface VariablesContextData {
    [name: string]: string | number | Big | boolean | Error | undefined;
}

export const VariablesContext = React.createContext<VariablesContextData>({});

export const useVariablesContext = () => useContext(VariablesContext);
